import { connect } from 'react-redux';
import actions from '../redux/actions/user';
import LoginHistory from '../component/LoginHistory';

const mapStateToProps = (state) => ({
  loginHistories: state.user.loginHistories,
  userLoginHistory: state.user.userLoginHistory,
});

const mapDispatchToProps = (dispatch) => ({
  loginHistoryAction: (params, callback) => {
    dispatch(actions.loginHistoryAction(params, callback));
  },
  userLoginHitoryAction: (params, callback) => {
    dispatch(actions.userLoginHitoryAction(params, callback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginHistory);
